import { useState } from "react";
import { FormulaDisplay } from "./FormulaDisplay";
import { ParsedMetric } from "./metrics.types";
import { AncestorTree } from "./AncestorTree";
import { AccountLabelFetch } from "./components/AccountLabelFetch";

export function MetricLineage({ metric }: { metric: ParsedMetric }) {
    const [selectedRef, setSelectedRef] = useState<string>("$0");
    const selectedValue = metric.values.find(
        (value) => value.ref === selectedRef,
    );
    const fileId = selectedValue?.meta?.dataAssetId;
    const accountId = selectedValue?.meta?.accountId;

    return (
        <div className="mt-1 flex flex-col gap-2">
            <FormulaDisplay
                metric={metric as ParsedMetric}
                onValueClick={(value) => {
                    console.log(value);
                    setSelectedRef(value.ref);
                }}
                selectedRef={selectedRef}
            />
            {accountId && <AccountLabelFetch accountId={accountId} />}
            {fileId && <AncestorTree fileId={fileId} />}
        </div>
    );
}
